export const environment = {
  production: true,
  apiRoot: '',
  allowedUrls: [ '/api' ],
  authApi: '/api/auth'
};
